import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import useAuth from '../../hooks/useAuth';

const AdminGuard = ({ children }) => {
  const { isLoggedIn } = useAuth();
  const { user } = useAuth();
  const navigate = useNavigate();
  const cmpId = JSON.parse(localStorage.getItem('cmpId'));

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/auth/signin-2', { replace: true });
    }

    if (isLoggedIn && !cmpId) {
      navigate('/auth/tabs-auth', { replace: true });
    }
    if (isLoggedIn && cmpId && user.adminYn!=='Y') {
      navigate('/hr/error', { replace: true });
    } else return;
  }, [isLoggedIn, navigate, cmpId, user]);

  return <React.Fragment>{children}</React.Fragment>;
};

export default AdminGuard;
